"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wix = void 0;
var promisifier_1 = require("./promisifier");
var provider_1 = require("./provider");
__exportStar(require("./models/js-sdk"), exports);
__exportStar(require("./models/provided-js-sdk"), exports);
exports.Wix = promisifier_1.promisify(provider_1.provide());
//# sourceMappingURL=index.js.map